<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
     
========================================================================================== -->


<template>
  <div id="profile-page">
    <!-- PROFILE HEADER -->
    <div class="profile-header mb-6">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img
            :src="require(`@/assets/images/pages/${userCoverImg}`)"
            alt="user-profile-cover"
            class="responsive rounded"
            style="height:400px"
          />
        </div>
        <div class="profile-img-container pointer-events-none">
          <div>
            <vs-avatar
              class="user-profile-img"
              :src="require(`@/assets/images/profile/user-uploads/${userInfo.profileImg}`)"
              size="85px"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- COL AREA -->
    <div class="vx-row">
      <!-- COL 2 -->
      <div class="vx-col w-full mx-auto self-center lg:w-1/2">
        <vx-card class="mt-base">
          <div>
            <!-- POST CONTENT -->
            <div class="post-content">
              <div class="vx-card__title text-center">
                <h4 class="mb-4">User Profile</h4>
              </div>
              <div class="clearfix">
                <vs-input
                  v-validate="'required|alpha_dash|min:3'"
                  data-vv-validate-on="blur"
                  label-placeholder="Username"
                  name="Username"
                  placeholder="Username"
                  v-model="userDetails.userName"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors.first('Username') }}</span>

                <vs-input
                  v-validate="'required|email'"
                  data-vv-validate-on="blur"
                  name="Email"
                  type="email"
                  label-placeholder="Email"
                  placeholder="Email"
                  :disabled="true"
                  v-model="userDetails.email"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first('Email') }}</span>
                <vs-input
                  v-validate="{required:true,regex: '^(([6-9]{1}[0-9]{9}))$' }"
                  data-vv-validate-on="blur"
                  label-placeholder="Phone Number"
                  placeholder="Phone Number"
                  name="Phone Number"
                  v-model="userDetails.phoneNumber"
                  class="mt-6 w-full"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Phone Number')"
                >{{ errors.first('Phone Number') }}</span>
                <div class="flex flex-wrap items-center justify-center p-6">
                  <vs-button
                    color="success"
                    class="mr-6"
                    :disabled="!validateForm"
                    @click="updateUserDetails"
                  >Update</vs-button>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- COL 3 -->
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  data() {
    return {
      isNavOpen: false,
      userPoll: "",
      userDetails: "",
      endpoint: this.$store.state.endpoint2,
      userInfo: {
        profileImg: "user-14.png"
      },
      userCoverImg: "vuesax-login-bg1.jpg",
      wasSidebarOpen: null
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.userDetails.userName != "" &&
        this.userDetails.email != "" &&
        this.userDetails.phoneNumber != ""
      );
    }
  },
  created() {
    this.userDetails = JSON.parse(JSON.stringify(this.$store.state.userInfo));
  },
  methods: {
    loadContent() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-load-more-posts",
        scale: 0.45
      });
      setTimeout(() => {
        this.$vs.loading.close("#button-load-more-posts > .con-vs-loading");
      }, 3000);
    },
    updateUserDetails() {
      var payload = this.userDetails;

      console.log(payload.email);
      this.$http
        .post(this.endpoint + "/updateuser", payload)
        .then(response => {
          this.$vs.notify({
            title: "Profile Updated",
            text: "Your Profile is successfully Updated!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
          const data = {
            userDetails: {
              email: payload.email
            },
            notify: this.$vs.notify
          };
          console.log(data);
          this.$store.dispatch("getUserData", data);
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: error.response.data,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  },
  components: {
    videoPlayer
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/profile.scss";
</style>